module.exports = __webpack_public_path__ + "images/d38312120e38884ade5e9448bd80886c-IMG_7696.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_7696.jpg
// module id = ./src/assets/images/slides/living2/IMG_7696.jpg
// module chunks = 0